module.exports = __webpack_public_path__ + "img/guoqi.e6c8f677.png";